module.exports = __webpack_public_path__ + "img/34-ABITO-SUNRISE-U-COLORI-GARZA-COLORI-RETE-SPOLVERINO-SUPER-U-COLORI-GARZA-COLORI-RETE9.4ed12142.jpg";